import { render } from "./StatisticsQuotesView.vue?vue&type=template&id=8c033060&scoped=true"
import script from "./StatisticsQuotesView.vue?vue&type=script&lang=js"
export * from "./StatisticsQuotesView.vue?vue&type=script&lang=js"

import "./StatisticsQuotesView.vue?vue&type=style&index=0&id=8c033060&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c033060"]])

export default __exports__